// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zrqYgDrDhcoFAKPQ {
	max-width: 1310px;
	margin: 0 auto;
	padding-bottom: 96px;
}

.zrqYgDrDhcoFAKPQ h2 {
	color: #303030;
	font-size: 30px;
	font-weight: 600;
	margin: 0;
}

.hsPZLNpokDU5D7zo {
	margin: 45px 0 30px 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.gD9v2j04II49ziN4 {
	color: #000000;
	background-color: transparent;
	border: none;
}

.gD9v2j04II49ziN4 i {
	font-size: 16px;
	background-color: #f2e1bc;
	padding: 10px;
	border-radius: 8px;
	margin-left: 12px;
}

.zrqYgDrDhcoFAKPQ .p-datatable-table {
	border-radius: 16px;
	overflow: hidden;
}

.zrqYgDrDhcoFAKPQ .p-datatable-thead th {
	background-color: #f2e1bc;
	border: 1px solid #f3f5f7;
	padding: 18px 30px;
}

.zrqYgDrDhcoFAKPQ .p-datatable-thead th:first-child > div {
	display: flex;
	justify-content: flex-start;
}

.zrqYgDrDhcoFAKPQ .p-datatable-thead th > div {
	display: flex;
	justify-content: center;
	color: #303030;
	font-size: 18px;
}

.zrqYgDrDhcoFAKPQ .p-datatable-tbody td {
	border: 1px solid #f3f5f7;
	padding: 9px 8px;
}

.zrqYgDrDhcoFAKPQ .p-datatable-tbody tr td:first-child {
	text-align: left;
}

.zrqYgDrDhcoFAKPQ .p-datatable-tbody tr .DtyekuSb7Uj21RVS {
	display: flex;
	justify-content: center;
	align-items: center;
}

.jUtrskNrEH01kSdy {
	background-size: cover;
	height: 50px;
	width: 71px;
	background-color: gray;
	color: #ffffff;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 6px;
	overflow: hidden;
}

.jUtrskNrEH01kSdy i {
	display: none;
}

.zrqYgDrDhcoFAKPQ .p-datatable-tbody tr:hover .jUtrskNrEH01kSdy i {
	display: block;
}

.zrqYgDrDhcoFAKPQ .p-datatable-tbody tr:hover .jUtrskNrEH01kSdy div {
	width: 100%;
	height: 100%;
	background-color: #2e2e2e55;
	backdrop-filter: blur(2px);
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 6px;
}

.zrqYgDrDhcoFAKPQ .p-datatable-tbody tr td {
	text-align: center;
}

.zrqYgDrDhcoFAKPQ .p-datatable-tbody tr:hover .DjDeXJb3MyAccOhg {
	background-color: #e1e7ed;
}

.DjDeXJb3MyAccOhg {
	padding: 28px 22px;
	border-radius: 6px;
}

.EiGPAZxtck4lWVwa {
	display: flex;
	gap: 8px;
}

.niRHUu1wKJkRXBMz,
.P5afYxETVukvrdP8,
.HFdL9M0hU58RdMI_ {
	width: 75px;
	height: 67px;
}

.zrqYgDrDhcoFAKPQ .p-datatable-tbody tr:hover .niRHUu1wKJkRXBMz {
	background-color: #c5f3c1;
}

.zrqYgDrDhcoFAKPQ .p-datatable-tbody tr:hover .P5afYxETVukvrdP8 {
	background-color: #e1e7ed;
}

.zrqYgDrDhcoFAKPQ .p-datatable-tbody tr:hover .HFdL9M0hU58RdMI_ {
	background-color: #ffcaca;
}

.niRHUu1wKJkRXBMz span::before {
	color: #56be4d;
	font-size: 20px;
}

.HFdL9M0hU58RdMI_ span::before {
	color: #dd0000;
	font-size: 20px;
}

.zrqYgDrDhcoFAKPQ .p-datatable-tbody tr:hover .niRHUu1wKJkRXBMz span::before {
	color: #185625;
}

.zrqYgDrDhcoFAKPQ .p-datatable-tbody tr:hover .P5afYxETVukvrdP8 span::before {
	color: #20336c;
}

.P5afYxETVukvrdP8 span::before {
	color: #4d87be;
	font-size: 20px;
}

.itX3mpNlk7o9KpXs {
	width: 114px;
	height: 67px;
}

.FM5hKJpQsDsnrmZm {
	width: 100%;
}

.FM5hKJpQsDsnrmZm > span {
	width: 100%;
	display: flex;
	justify-content: center;
	background-color: #4d87be;
	border-radius: 16px;
	padding: 14px 0px;
	font-size: 18px;
	font-weight: 600;
}

.FM5hKJpQsDsnrmZm > span:hover {
	background-color: #20336C;
}

.FM5hKJpQsDsnrmZm > span > span {
	width: fit-content;
	flex-grow: 0;
}

.zrqYgDrDhcoFAKPQ .p-datatable-tbody tr:hover .itX3mpNlk7o9KpXs {
	background-color: #e1e7ed;
}

.VAjpUT5tELAV8FBG {
	display: inline-block;
}

.UoGQNR5b9gEdNw88 {
	background-color: #f2efea;
	padding: 20px;
	display: flex;
	justify-content: center;
}

.QD4ic1JvMf8fKFCO {
	width: 250px;
	height: 250px;
	border-radius: 54px;
	overflow: hidden;
}

.QD4ic1JvMf8fKFCO .a0SrkNxzqlE4xNDi {
	height: 173px;
	background-color: gray;
	background-size: cover;
}

.QD4ic1JvMf8fKFCO .S6aaQnYyUsMTiL2x {
	height: 77px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-transform: uppercase;
	font-size: 16px;
	font-family: "Roboto";
	background-color: #ffffff;
}

.gANZFWDRKvIWKxfb {
	border-radius: 16px;
	font-size: 18px;
	padding: 14px 20px;
	background-color: #ffffff;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
}

.MQLa7anuZwFcL9Tv {
	border-radius: 16px 0 0 16px !important;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
}

.LN0qQ3c3C743JwOc {
	border-radius: 0 16px 16px 0 !important;
	background-color: #ffffff;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
}

.kFjPjRbhjfMXGBVr {
	background-color: #e1e7ed;
	border-radius: 16px;
	overflow: hidden;
}

.kFjPjRbhjfMXGBVr .p-button {
	background-color: transparent;
	border: none;
	font-size: 20px;
	padding: 15px 0px;
}

.kFjPjRbhjfMXGBVr .p-highlight {
	background-color: #4d87be;
	border-radius: 16px;
}

.T6fI_qARG0UeuY0C {
	width: 100%;
	background-color: #56be4d;
	border-radius: 16px;
	padding: 18px 0px;
	color: #ffffff;
	border: none;
	font-size: 20px;
	font-weight: 600;
}

.T6fI_qARG0UeuY0C:hover {
	background-color: #185625;
}

.ifFpTZaOIB8PYXKo {
	width: 100%;
	background-color: #DD0000;
	border-radius: 16px;
	padding: 18px 20px;
	font-size: 20px;
	font-weight: 600;
	color: #ffffff;
	border: none;
}

.ifFpTZaOIB8PYXKo:hover {
	background-color: #721010;
}

.KH7aNIdbqLQ7G2lZ {
	width: 100%;
	background-color: #F3F5F7;
	border-radius: 16px;
	padding: 10px 20px;
	color: #4D87BE;
	font-size: 20px;
	font-weight: 600;
	border: none;
}

.KH7aNIdbqLQ7G2lZ:hover {
	color: #305375;
}

.HcaF7UIrwMwelOyW {
	width: 541px !important;
	height: 354px !important;
	background-color: #F3F5F7;
	border-radius: 25px !important;
}

.HcaF7UIrwMwelOyW .p-dialog {
	border-radius: 25px !important;
	background-color: #F3F5F7;
}

.HcaF7UIrwMwelOyW .p-dialog-footer {
	border-bottom-right-radius: 25px !important;
	border-bottom-left-radius: 25px !important;
	background-color: #F3F5F7;
}

.HcaF7UIrwMwelOyW .p-dialog-header {
	border-top-right-radius: 25px !important;
	border-top-left-radius: 25px !important;
	background-color: #F3F5F7;
}

.HcaF7UIrwMwelOyW .p-dialog-content{
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

.HcaF7UIrwMwelOyW .Ri28uUeCe9kq_xUo {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	font-size: 20px;
	font-weight: 400;
}

.HcaF7UIrwMwelOyW .p-dialog-title {
	font-size: 30px !important;
	font-weight: 700 !important;
}

.HcaF7UIrwMwelOyW .p-dialog-content {
	background-color: #F3F5F7;
}

.lv6n7nr71rgEgMJu {
	width: 674px !important;
	height: fit-content;
	background-color: #F3F5F7;
	border-radius: 16px !important;
}

.lv6n7nr71rgEgMJu .p-dialog {
	border-radius: 16px !important;
}

.lv6n7nr71rgEgMJu .p-dialog-footer {
	border-bottom-right-radius: 16px !important;
	border-bottom-left-radius: 16px !important;
	background-color: #F3F5F7;
}

.lv6n7nr71rgEgMJu .p-dialog-header {
	border-top-right-radius: 16px !important;
	border-top-left-radius: 16px !important;
	background-color: #F3F5F7;
}

.lv6n7nr71rgEgMJu .p-dialog-title {
	font-size: 30px !important;
	font-weight: 700 !important;
}

.lv6n7nr71rgEgMJu .p-dialog-content {
	background-color: #F3F5F7;
}

.lv6n7nr71rgEgMJu .field label {
	font-size: 20px !important;
	font-weight: 400 !important;
}

.fiGJWcoC_csoWTiB {
	display: flex;
	flex-direction: column;
	gap: 6px;
}

.fzjluiG6M5k4WZ7_ {
	background: #ffffff;
	padding: 20px;
	border-radius: 8px;
	box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.LjuIDlYmk4DaoULQ {
	display: flex;
	flex-direction: column;
}

.zUOuSRV1ptMVwXiM {
	font-weight: 500;
	color: #303030;
	font-size: 14px;
}

.aJ05ftIbLBgARvzT {
	color: #888888;
	font-weight: 400;
	font-size: 12px;
	margin-left: 3px;
}

.DXCl0yJTxy0rLfzY {
	display: flex;
	gap: 12px;
}

.o3L_BgI0PvwHWWo4 {
	color: #1976d2;
	background: none;
	border: none;
}

.CDzmsGTzc4jCfEaL {
	color: #d32f2f;
	background: none;
	border: none;
	font-size: 20px;
}

.o3L_BgI0PvwHWWo4 i::before,
.CDzmsGTzc4jCfEaL i::before {
	font-size: 26px;
}

@media screen and (max-width: 790px) {
	.zrqYgDrDhcoFAKPQ .p-datatable .p-datatable-thead > tr > th,
	.zrqYgDrDhcoFAKPQ .p-datatable .p-datatable-tfoot > tr > td {
		display: none !important;
	}
	
	.zrqYgDrDhcoFAKPQ .p-datatable .p-datatable-tbody > tr {
		display: flex;
		flex-direction: row;
	}
	
	.zrqYgDrDhcoFAKPQ .p-datatable .p-datatable-tbody > tr > td:not(:last-child) {
		border: 0 none;
	}
	
	.zrqYgDrDhcoFAKPQ .p-datatable .p-datatable-tbody > tr > td:nth-child(2) {
		color: #7B7B7B;
		font-size: 12px;
		margin-left: -40px;
	}
	
	
	.zrqYgDrDhcoFAKPQ .p-datatable .p-datatable-tbody > tr > td {
		display: flex;
		width: 100% !important;
		align-items: center;
		justify-content: space-between !important;
	}
	
	.zrqYgDrDhcoFAKPQ .p-datatable .p-datatable-tbody > tr > td > .p-column-title {
		display: block;
	}
}

@media screen and (max-width: 425px) {
	.hsPZLNpokDU5D7zo {
		margin: 45px 0 8px 0;
		display: flex;
		flex-direction: column;
	}
	
	.hsPZLNpokDU5D7zo h2 {
		font-size: 20px;
		font-weight: 700;
	}
	
	.hsPZLNpokDU5D7zo button,
	.hsPZLNpokDU5D7zo h2 {
		width: 100%;
	}
	
	.hsPZLNpokDU5D7zo button {
		padding: 0;
		margin-top: 12px;
	}
	
	.hsPZLNpokDU5D7zo button > span {
		display: none;
	}
	
	.hsPZLNpokDU5D7zo button > i {
		margin-left: 0;
		width: 100%;
	}
	
	.HcaF7UIrwMwelOyW,
	.lv6n7nr71rgEgMJu {
		width: 350px !important;
	}
	
	.lv6n7nr71rgEgMJu .field label {
		font-size: 14px !important;
	}
	
	.HcaF7UIrwMwelOyW .p-dialog-title,
	.lv6n7nr71rgEgMJu .p-dialog-title {
		font-size: 20px !important;
		font-weight: 700 !important;
	}
	
	.HcaF7UIrwMwelOyW .Ri28uUeCe9kq_xUo {
		font-size: 16px;
	}
	
	.gANZFWDRKvIWKxfb {
		font-size: 14px;
		padding: 14px 20px;
		background-color: #ffffff;
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
	}
	
	.MQLa7anuZwFcL9Tv {
		font-size: 14px;
	}
	
	.T6fI_qARG0UeuY0C {
		padding: 14px 0;
		font-size: 16px;
	}
	
	.ifFpTZaOIB8PYXKo {
		border-radius: 8px;
		padding: 14px 16px;
		font-size: 16px;
	}
	
	.KH7aNIdbqLQ7G2lZ {
		border-radius: 8px;
		padding: 10px 20px;
		font-size: 16px;
	}
}`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/ChefManagement.module.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,qBAAqB;CACrB,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,6BAA6B;CAC7B,YAAY;AACb;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,aAAa;CACb,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,WAAW;CACX,sBAAsB;CACtB,cAAc;CACd,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,2BAA2B;CAC3B,0BAA0B;CAC1B,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,QAAQ;AACT;;AAEA;;;CAGC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,yBAAyB;CACzB,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,aAAa;CACb,uBAAuB;AACxB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,yBAAyB;CACzB,eAAe;CACf,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,yBAAyB;CACzB,sGAAsG;AACvG;;AAEA;CACC,uCAAuC;CACvC,sGAAsG;AACvG;;AAEA;CACC,uCAAuC;CACvC,yBAAyB;CACzB,sGAAsG;AACvG;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;CAC7B,YAAY;CACZ,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,iBAAiB;CACjB,cAAc;CACd,YAAY;CACZ,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,uBAAuB;CACvB,wBAAwB;CACxB,yBAAyB;CACzB,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;CAC9B,yBAAyB;AAC1B;;AAEA;CACC,2CAA2C;CAC3C,0CAA0C;CAC1C,yBAAyB;AAC1B;;AAEA;CACC,wCAAwC;CACxC,uCAAuC;CACvC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;CACvB,mBAAmB;CACnB,yBAAyB;CACzB,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,2CAA2C;CAC3C,0CAA0C;CAC1C,yBAAyB;AAC1B;;AAEA;CACC,wCAAwC;CACxC,uCAAuC;CACvC,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,kBAAkB;CAClB,gDAAgD;CAChD,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,YAAY;CACZ,eAAe;AAChB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC;;EAEC,wBAAwB;CACzB;;CAEA;EACC,aAAa;EACb,mBAAmB;CACpB;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,cAAc;EACd,eAAe;EACf,kBAAkB;CACnB;;;CAGA;EACC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;CAC1C;;CAEA;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,oBAAoB;EACpB,aAAa;EACb,sBAAsB;CACvB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;;EAEC,WAAW;CACZ;;CAEA;EACC,UAAU;EACV,gBAAgB;CACjB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,cAAc;EACd,WAAW;CACZ;;CAEA;;EAEC,uBAAuB;CACxB;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;;EAEC,0BAA0B;EAC1B,2BAA2B;CAC5B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,sGAAsG;CACvG;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,eAAe;CAChB;;CAEA;EACC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;CAChB;;CAEA;EACC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;CAChB;AACD","sourcesContent":[".pageWrapper {\r\n\tmax-width: 1310px;\r\n\tmargin: 0 auto;\r\n\tpadding-bottom: 96px;\r\n}\r\n\r\n.pageWrapper h2 {\r\n\tcolor: #303030;\r\n\tfont-size: 30px;\r\n\tfont-weight: 600;\r\n\tmargin: 0;\r\n}\r\n\r\n.header {\r\n\tmargin: 45px 0 30px 0;\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n}\r\n\r\n.createBtn {\r\n\tcolor: #000000;\r\n\tbackground-color: transparent;\r\n\tborder: none;\r\n}\r\n\r\n.createBtn i {\r\n\tfont-size: 16px;\r\n\tbackground-color: #f2e1bc;\r\n\tpadding: 10px;\r\n\tborder-radius: 8px;\r\n\tmargin-left: 12px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-table) {\r\n\tborder-radius: 16px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th) {\r\n\tbackground-color: #f2e1bc;\r\n\tborder: 1px solid #f3f5f7;\r\n\tpadding: 18px 30px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th:first-child > div) {\r\n\tdisplay: flex;\r\n\tjustify-content: flex-start;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th > div) {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tcolor: #303030;\r\n\tfont-size: 18px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody td) {\r\n\tborder: 1px solid #f3f5f7;\r\n\tpadding: 9px 8px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td:first-child) {\r\n\ttext-align: left;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr) .cellImageWrapper {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n.imageCell {\r\n\tbackground-size: cover;\r\n\theight: 50px;\r\n\twidth: 71px;\r\n\tbackground-color: gray;\r\n\tcolor: #ffffff;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tborder-radius: 6px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.imageCell i {\r\n\tdisplay: none;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .imageCell i {\r\n\tdisplay: block;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .imageCell div {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground-color: #2e2e2e55;\r\n\tbackdrop-filter: blur(2px);\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tborder-radius: 6px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td) {\r\n\ttext-align: center;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .cellInsider {\r\n\tbackground-color: #e1e7ed;\r\n}\r\n\r\n.cellInsider {\r\n\tpadding: 28px 22px;\r\n\tborder-radius: 6px;\r\n}\r\n\r\n.cellSoundWrapper {\r\n\tdisplay: flex;\r\n\tgap: 8px;\r\n}\r\n\r\n.playBtn,\r\n.soundBtn,\r\n.deleteBtn {\r\n\twidth: 75px;\r\n\theight: 67px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .playBtn {\r\n\tbackground-color: #c5f3c1;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .soundBtn {\r\n\tbackground-color: #e1e7ed;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .deleteBtn {\r\n\tbackground-color: #ffcaca;\r\n}\r\n\r\n.playBtn span::before {\r\n\tcolor: #56be4d;\r\n\tfont-size: 20px;\r\n}\r\n\r\n.deleteBtn span::before {\r\n\tcolor: #dd0000;\r\n\tfont-size: 20px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .playBtn span::before {\r\n\tcolor: #185625;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .soundBtn span::before {\r\n\tcolor: #20336c;\r\n}\r\n\r\n.soundBtn span::before {\r\n\tcolor: #4d87be;\r\n\tfont-size: 20px;\r\n}\r\n\r\n.activeBtn {\r\n\twidth: 114px;\r\n\theight: 67px;\r\n}\r\n\r\n.uploadBtn {\r\n\twidth: 100%;\r\n}\r\n\r\n.uploadBtn > span {\r\n\twidth: 100%;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tbackground-color: #4d87be;\r\n\tborder-radius: 16px;\r\n\tpadding: 14px 0px;\r\n\tfont-size: 18px;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.uploadBtn > span:hover {\r\n\tbackground-color: #20336C;\r\n}\r\n\r\n.uploadBtn > span > span {\r\n\twidth: fit-content;\r\n\tflex-grow: 0;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .activeBtn {\r\n\tbackground-color: #e1e7ed;\r\n}\r\n\r\n.cardWrapper {\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.preview {\r\n\tbackground-color: #f2efea;\r\n\tpadding: 20px;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n}\r\n\r\n.stationCard {\r\n\twidth: 250px;\r\n\theight: 250px;\r\n\tborder-radius: 54px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.stationCard .image {\r\n\theight: 173px;\r\n\tbackground-color: gray;\r\n\tbackground-size: cover;\r\n}\r\n\r\n.stationCard .titleWrapper {\r\n\theight: 77px;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\ttext-transform: uppercase;\r\n\tfont-size: 16px;\r\n\tfont-family: \"Roboto\";\r\n\tbackground-color: #ffffff;\r\n}\r\n\r\n.input {\r\n\tborder-radius: 16px;\r\n\tfont-size: 18px;\r\n\tpadding: 14px 20px;\r\n\tbackground-color: #ffffff;\r\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.phonePrefix {\r\n\tborder-radius: 16px 0 0 16px !important;\r\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.inputPhone {\r\n\tborder-radius: 0 16px 16px 0 !important;\r\n\tbackground-color: #ffffff;\r\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.selectButton {\r\n\tbackground-color: #e1e7ed;\r\n\tborder-radius: 16px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.selectButton :global(.p-button) {\r\n\tbackground-color: transparent;\r\n\tborder: none;\r\n\tfont-size: 20px;\r\n\tpadding: 15px 0px;\r\n}\r\n\r\n.selectButton :global(.p-highlight) {\r\n\tbackground-color: #4d87be;\r\n\tborder-radius: 16px;\r\n}\r\n\r\n.saveBtn {\r\n\twidth: 100%;\r\n\tbackground-color: #56be4d;\r\n\tborder-radius: 16px;\r\n\tpadding: 18px 0px;\r\n\tcolor: #ffffff;\r\n\tborder: none;\r\n\tfont-size: 20px;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.saveBtn:hover {\r\n\tbackground-color: #185625;\r\n}\r\n\r\n.deleteDialogBtn {\r\n\twidth: 100%;\r\n\tbackground-color: #DD0000;\r\n\tborder-radius: 16px;\r\n\tpadding: 18px 20px;\r\n\tfont-size: 20px;\r\n\tfont-weight: 600;\r\n\tcolor: #ffffff;\r\n\tborder: none;\r\n}\r\n\r\n.deleteDialogBtn:hover {\r\n\tbackground-color: #721010;\r\n}\r\n\r\n.cancelDialogBtn {\r\n\twidth: 100%;\r\n\tbackground-color: #F3F5F7;\r\n\tborder-radius: 16px;\r\n\tpadding: 10px 20px;\r\n\tcolor: #4D87BE;\r\n\tfont-size: 20px;\r\n\tfont-weight: 600;\r\n\tborder: none;\r\n}\r\n\r\n.cancelDialogBtn:hover {\r\n\tcolor: #305375;\r\n}\r\n\r\n.deleteModal {\r\n\twidth: 541px !important;\r\n\theight: 354px !important;\r\n\tbackground-color: #F3F5F7;\r\n\tborder-radius: 25px !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog) {\r\n\tborder-radius: 25px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-footer) {\r\n\tborder-bottom-right-radius: 25px !important;\r\n\tborder-bottom-left-radius: 25px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-header) {\r\n\tborder-top-right-radius: 25px !important;\r\n\tborder-top-left-radius: 25px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content){\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tflex-direction: column;\r\n}\r\n\r\n.deleteModal .text {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\ttext-align: center;\r\n\tfont-size: 20px;\r\n\tfont-weight: 400;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-title) {\r\n\tfont-size: 30px !important;\r\n\tfont-weight: 700 !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content) {\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.chefModal {\r\n\twidth: 674px !important;\r\n\theight: fit-content;\r\n\tbackground-color: #F3F5F7;\r\n\tborder-radius: 16px !important;\r\n}\r\n\r\n.chefModal :global(.p-dialog) {\r\n\tborder-radius: 16px !important;\r\n}\r\n\r\n.chefModal :global(.p-dialog-footer) {\r\n\tborder-bottom-right-radius: 16px !important;\r\n\tborder-bottom-left-radius: 16px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.chefModal :global(.p-dialog-header) {\r\n\tborder-top-right-radius: 16px !important;\r\n\tborder-top-left-radius: 16px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.chefModal :global(.p-dialog-title) {\r\n\tfont-size: 30px !important;\r\n\tfont-weight: 700 !important;\r\n}\r\n\r\n.chefModal :global(.p-dialog-content) {\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.chefModal :global(.field) label {\r\n\tfont-size: 20px !important;\r\n\tfont-weight: 400 !important;\r\n}\r\n\r\n.cardList {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 6px;\r\n}\r\n\r\n.cardItem {\r\n\tbackground: #ffffff;\r\n\tpadding: 20px;\r\n\tborder-radius: 8px;\r\n\tbox-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n}\r\n\r\n.cardInfo {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n}\r\n\r\n.name {\r\n\tfont-weight: 500;\r\n\tcolor: #303030;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.subfield {\r\n\tcolor: #888888;\r\n\tfont-weight: 400;\r\n\tfont-size: 12px;\r\n\tmargin-left: 3px;\r\n}\r\n\r\n.actions {\r\n\tdisplay: flex;\r\n\tgap: 12px;\r\n}\r\n\r\n.cardEditBtn {\r\n\tcolor: #1976d2;\r\n\tbackground: none;\r\n\tborder: none;\r\n}\r\n\r\n.cardDeleteBtn {\r\n\tcolor: #d32f2f;\r\n\tbackground: none;\r\n\tborder: none;\r\n\tfont-size: 20px;\r\n}\r\n\r\n.cardEditBtn i::before,\r\n.cardDeleteBtn i::before {\r\n\tfont-size: 26px;\r\n}\r\n\r\n@media screen and (max-width: 790px) {\r\n\t.pageWrapper :global(.p-datatable .p-datatable-thead > tr > th),\r\n\t.pageWrapper :global(.p-datatable .p-datatable-tfoot > tr > td) {\r\n\t\tdisplay: none !important;\r\n\t}\r\n\t\r\n\t.pageWrapper :global(.p-datatable .p-datatable-tbody > tr) {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: row;\r\n\t}\r\n\t\r\n\t.pageWrapper :global(.p-datatable .p-datatable-tbody > tr > td:not(:last-child)) {\r\n\t\tborder: 0 none;\r\n\t}\r\n\t\r\n\t.pageWrapper :global(.p-datatable .p-datatable-tbody > tr > td:nth-child(2)) {\r\n\t\tcolor: #7B7B7B;\r\n\t\tfont-size: 12px;\r\n\t\tmargin-left: -40px;\r\n\t}\r\n\t\r\n\t\r\n\t.pageWrapper :global(.p-datatable .p-datatable-tbody > tr > td) {\r\n\t\tdisplay: flex;\r\n\t\twidth: 100% !important;\r\n\t\talign-items: center;\r\n\t\tjustify-content: space-between !important;\r\n\t}\r\n\t\r\n\t.pageWrapper :global(.p-datatable .p-datatable-tbody > tr > td > .p-column-title) {\r\n\t\tdisplay: block;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 425px) {\r\n\t.header {\r\n\t\tmargin: 45px 0 8px 0;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t}\r\n\t\r\n\t.header h2 {\r\n\t\tfont-size: 20px;\r\n\t\tfont-weight: 700;\r\n\t}\r\n\t\r\n\t.header button,\r\n\t.header h2 {\r\n\t\twidth: 100%;\r\n\t}\r\n\t\r\n\t.header button {\r\n\t\tpadding: 0;\r\n\t\tmargin-top: 12px;\r\n\t}\r\n\t\r\n\t.header button > span {\r\n\t\tdisplay: none;\r\n\t}\r\n\t\r\n\t.header button > i {\r\n\t\tmargin-left: 0;\r\n\t\twidth: 100%;\r\n\t}\r\n\t\r\n\t.deleteModal,\r\n\t.chefModal {\r\n\t\twidth: 350px !important;\r\n\t}\r\n\t\r\n\t.chefModal :global(.field) label {\r\n\t\tfont-size: 14px !important;\r\n\t}\r\n\t\r\n\t.deleteModal :global(.p-dialog-title),\r\n\t.chefModal :global(.p-dialog-title) {\r\n\t\tfont-size: 20px !important;\r\n\t\tfont-weight: 700 !important;\r\n\t}\r\n\t\r\n\t.deleteModal .text {\r\n\t\tfont-size: 16px;\r\n\t}\r\n\t\r\n\t.input {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 14px 20px;\r\n\t\tbackground-color: #ffffff;\r\n\t\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n\t}\r\n\t\r\n\t.phonePrefix {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t\r\n\t.saveBtn {\r\n\t\tpadding: 14px 0;\r\n\t\tfont-size: 16px;\r\n\t}\r\n\t\r\n\t.deleteDialogBtn {\r\n\t\tborder-radius: 8px;\r\n\t\tpadding: 14px 16px;\r\n\t\tfont-size: 16px;\r\n\t}\r\n\t\r\n\t.cancelDialogBtn {\r\n\t\tborder-radius: 8px;\r\n\t\tpadding: 10px 20px;\r\n\t\tfont-size: 16px;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `zrqYgDrDhcoFAKPQ`;
export var header = `hsPZLNpokDU5D7zo`;
export var createBtn = `gD9v2j04II49ziN4`;
export var cellImageWrapper = `DtyekuSb7Uj21RVS`;
export var imageCell = `jUtrskNrEH01kSdy`;
export var cellInsider = `DjDeXJb3MyAccOhg`;
export var cellSoundWrapper = `EiGPAZxtck4lWVwa`;
export var playBtn = `niRHUu1wKJkRXBMz`;
export var soundBtn = `P5afYxETVukvrdP8`;
export var deleteBtn = `HFdL9M0hU58RdMI_`;
export var activeBtn = `itX3mpNlk7o9KpXs`;
export var uploadBtn = `FM5hKJpQsDsnrmZm`;
export var cardWrapper = `VAjpUT5tELAV8FBG`;
export var preview = `UoGQNR5b9gEdNw88`;
export var stationCard = `QD4ic1JvMf8fKFCO`;
export var image = `a0SrkNxzqlE4xNDi`;
export var titleWrapper = `S6aaQnYyUsMTiL2x`;
export var input = `gANZFWDRKvIWKxfb`;
export var phonePrefix = `MQLa7anuZwFcL9Tv`;
export var inputPhone = `LN0qQ3c3C743JwOc`;
export var selectButton = `kFjPjRbhjfMXGBVr`;
export var saveBtn = `T6fI_qARG0UeuY0C`;
export var deleteDialogBtn = `ifFpTZaOIB8PYXKo`;
export var cancelDialogBtn = `KH7aNIdbqLQ7G2lZ`;
export var deleteModal = `HcaF7UIrwMwelOyW`;
export var text = `Ri28uUeCe9kq_xUo`;
export var chefModal = `lv6n7nr71rgEgMJu`;
export var cardList = `fiGJWcoC_csoWTiB`;
export var cardItem = `fzjluiG6M5k4WZ7_`;
export var cardInfo = `LjuIDlYmk4DaoULQ`;
export var name = `zUOuSRV1ptMVwXiM`;
export var subfield = `aJ05ftIbLBgARvzT`;
export var actions = `DXCl0yJTxy0rLfzY`;
export var cardEditBtn = `o3L_BgI0PvwHWWo4`;
export var cardDeleteBtn = `CDzmsGTzc4jCfEaL`;
export default ___CSS_LOADER_EXPORT___;
